import { Navigate, useSearchParams } from 'react-router-dom';
import type { ComponentProps } from 'react';

type RefNavigateProps = ComponentProps<typeof Navigate>;

/**
 * Navigate 래퍼 — 현재 URL에 ?ref= 파라미터가 있으면 이동 대상 URL에도 자동으로 붙여줍니다.
 */
export const RefNavigate = ({ to, ...props }: RefNavigateProps) => {
  const [searchParams] = useSearchParams();
  const ref = searchParams.get('ref');

  const toWithRef = (() => {
    if (!ref || typeof to !== 'string' || to.includes('ref=')) return to;
    const sep = to.includes('?') ? '&' : '?';
    return `${to}${sep}ref=${ref}`;
  })();

  return <Navigate to={toWithRef} {...props} />;
};
